import {observer} from "mobx-react";
import ButtonMain from "@dropDesk/presentation/components/buttons/button_main";
import {SectionButton} from "./styled";
import {FormEvent} from "react";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {ConstantsStyles} from "@dropDesk/domain/entities/constants/constants_keys";


const ButtonCreate = observer(
    ({
         isValidData,
         loading,
         handleSubmit,
     }: {
        loading: boolean,
        isValidData: boolean,
        handleSubmit: (event: FormEvent) => Promise<void>,
    }) => {

        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;

        return (
            <SectionButton>
                <ButtonMain
                    height={50}
                    letterFontSize={ConstantsStyles.buttonMainFontSize}
                    widthPercentage={100}
                    disabled={loading || !isValidData}
                    loading={loading}
                    color={colors.accent}
                    type={"submit"}
                    letter={"Cadastrar"}
                    onClick={handleSubmit}
                />
            </SectionButton>
        );
    });

export default ButtonCreate;
